export default Object.assign([
  {
    id: 44,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Aileen Rogers\' Teddy Bear ',
    tags: {
      alfa: 'Video'
    },
    cta: '',
    image: 'CWM-WebsiteTiles-EOTAS-F01-Teddy-72dpi.jpg',
    link: '/learn/aileen-rogers-teddy-bear/',
    cats: {
      themes: [113, 1115],
      types: [75]
    }
  },
  {
    id: 45,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Grant Campbell\'s Change Purse',
    tags: {
      alfa: 'Video'
    },
    cta: '',
    image: 'CWM-WebsiteTiles-EOTAS-F01-Purse-72dpi.jpg',
    link: '/learn/grant-campbells-change-purse/',
    cats: {
      themes: [214],
      types: [75]
    }
  },
  {
    id: 46,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'The Izzy Doll',
    tags: {
      alfa: 'Video'
    },
    cta: '',
    image: 'CWM-WebsiteTiles-EOTAS-F01-IzzyDoll-72dpi.jpg',
    link: '/learn/the-izzy-doll/',
    cats: {
      themes: [312, 511],
      types: [75]
    }
  },
  {
    id: 47,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'The Cartridge Case from the Funeral of Nichola Goddard',
    tags: {
      alfa: 'Video'
    },
    cta: '',
    image: 'CWM-WebsiteTiles-EOTAS-F01-CartridgeCase-72dpi.jpg',
    link: '/learn/the-cartridge-case-from-the-funeral-of-nichola-goddard/',
    cats: {
      themes: [414, 511, 1115],
      types: [75]
    }
  },
  {
    id: 48,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Tombstone of the Unknown Soldier',
    tags: {
      alfa: 'Video'
    },
    cta: '',
    image: 'CWM-WebsiteTiles-EOTAS-F01-UnknownSoldier-72dpi.jpg',
    link: '/learn/tombstone-of-the-unknown-soldier-video/',
    cats: {
      themes: [511, 113],
      types: [75]
    }
  },
  {
    id: 79,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'The Adie Family Service Flag',
    tags: {
      alfa: 'Video'
    },
    cta: '',
    image: 'CWM-WebsiteTiles-EOTAS-F01-ServiceFlag-72dpi.jpg',
    link: '/learn/the-adie-family-service-flag/',
    cats: {
      themes: [1311, 113],
      types: [75]
    }
  },
  {
    id: 80,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'A Letter from George Stonefish',
    tags: {
      alfa: 'Video'
    },
    cta: '',
    image: 'CWM-WebsiteTiles-EOTAS-F01-Letter-72dpi.jpg',
    link: '/learn/a-letter-from-george-stonefish/',
    cats: {
      themes: [917, 113],
      types: [75]
    }
  },
  {
    id: 81,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'A Photograph of Masumi Mitsui',
    tags: {
      alfa: 'Video'
    },
    cta: '',
    image: 'CWM-WebsiteTiles-EOTAS-F01-Photograph-72dpi.jpg',
    link: '/learn/a-photograph-of-masumi-mitsui/',
    cats: {
      themes: [113, 214, 511, 1220, 1311],
      types: [75]
    }
  },
  {
    id: 82,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Minnie Gray\'s Public Recognition Certificate ',
    tags: {
      alfa: 'Video'
    },
    cta: '',
    image: 'CWM-WebsiteTiles-EOTAS-F01-Certificate-72dpi.jpg',
    link: '/learn/minnie-grays-public-recognition-certificate/',
    cats: {
      themes: [214, 1020, 1115, 1311],
      types: [75]
    }
  },
  {
    id: 83,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'The Museum and the Lobby',
    tags: {
      alfa: 'Video'
    },
    cta: '',
    image: 'cwm-websitetiles-itcwt-f01-museum-72dpi.jpg',
    link: '/learn/the-museum-and-the-lobby/',
    cats: {
      themes: [511],
      types: [75]
    }
  },
  {
    id: 84,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Memorial Hall',
    tags: {
      alfa: 'Video'
    },
    cta: '',
    image: 'cwm-websitetiles-itwct-f01-memorialhall-72dpi.jpg',
    link: '/learn/memorial-hall/',
    cats: {
      themes: [511],
      types: [75]
    }
  },
  {
    id: 88,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Moriyama Regeneration Hall',
    tags: {
      alfa: 'Video'
    },
    cta: 'Learn more',
    image: 'cwm-websitetiles-itwct-f01-moriyama-72dpi.jpg',
    link: '/learn/moriyama-regeneration-hall/',
    cats: {
      themes: [1220, 511],
      types: [75]
    }
  },
  {
    id: 4,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Teddy',
    tags: {
      alfa: 'Artifact'
    },
    cta: 'Learn more',
    image: 'A01-20040015-001.jpg',
    link: '/learn/teddy/',
    cats: {
      themes: [113, 1115],
      types: [38]
    }
  },
  {
    id: 5,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Service Flag',
    tags: {
      alfa: 'Artifact'
    },
    cta: 'Learn more',
    image: 'Med06_GR01-20070073-001.jpg', // !!
    link: '/learn/service-flag/',
    cats: {
      themes: [113],
      types: [38]
    }
  },
  {
    id: 6,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Change Purse and Charred Map',
    tags: {
      alfa: 'Artifact'
    },
    cta: 'Learn more',
    image: 'A03-20190232-001_b.jpg',
    link: '/learn/change-purse-and-charred-map/',
    cats: {
      themes: [214],
      types: [38]
    }
  },
  {
    id: 7,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Battle-Damaged Shoes',
    tags: {
      alfa: 'Artifact'
    },
    cta: 'Learn more',
    image: 'A04-20170753-001.jpg',
    link: '/learn/battle-damaged-shoes/',
    cats: {
      themes: [214],
      types: [38]
    }
  },
  {
    id: 8,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'The Dag Hammarskjöld Medal',
    tags: {
      alfa: 'Artifact'
    },
    cta: 'Learn more',
    image: 'A05-20060217-001.jpg', // !!
    link: '/learn/the-dag-hammarskjold-medal/',
    cats: {
      themes: [312],
      types: [38]
    }
  },
  {
    id: 9,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Izzy Doll',
    tags: {
      alfa: 'Artifact'
    },
    cta: 'Learn more',
    image: 'A06-19980071-005.jpg',
    link: '/learn/izzy-doll/',
    cats: {
      themes: [312],
      types: [38]
    }
  },
  {
    id: 10,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Cartridge Case',
    tags: {
      alfa: 'Artifact'
    },
    cta: 'Learn more',
    image: 'A07-20070158-005.jpg',
    link: '/learn/cartridge-case/',
    cats: {
      themes: [414, 1115],
      types: [38]
    }
  },
  {
    id: 11,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Hockey Rink Panel',
    tags: {
      alfa: 'Artifact'
    },
    cta: 'Learn more',
    image: 'A08-20160664-001.jpg',
    link: '/learn/hockey-rink-panel/',
    cats: {
      themes: [414],
      types: [38]
    }
  },
  {
    id: 12,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Poppy',
    tags: {
      alfa: 'Artifact'
    },
    cta: 'Learn more',
    image: 'A09-19720228-001.jpg',
    link: '/learn/poppy/',
    cats: {
      themes: [511],
      types: [38]
    }
  },
  {
    id: 13,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Tombstone of the Unknown Soldier',
    tags: {
      alfa: 'Artifact'
    },
    cta: 'Learn more',
    image: 'A10-20000044-011.jpg',
    link: '/learn/tombstone-of-the-unknown-soldier/',
    cats: {
      themes: [113, 511],
      types: [38]
    }
  },
  {
    id: 49,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'British War Medal',
    tags: {
      alfa: 'Artifact'
    },
    cta: 'Learn more',
    image: 'A11a_20120205-001.jpg',
    link: '/learn/british-war-medal/',
    cats: {
      themes: [113, 1020],
      types: [38]
    }
  },
  {
    id: 50,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Memorial Plaque',
    tags: {
      alfa: 'Artifact'
    },
    cta: 'Learn more',
    image: 'A12a_19950037-010.jpg',
    link: '/learn/memorial-plaque/',
    cats: {
      themes: [113, 1115],
      types: [38]
    }
  },
  {
    id: 51,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Memorial Crosses',
    tags: {
      alfa: 'Artifact'
    },
    cta: 'Learn more',
    image: 'A13a_20030051-007008.jpg',
    link: '/learn/memorial-crosses/',
    cats: {
      themes: [113],
      types: [38]
    }
  },
  {
    id: 52,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Stained Glass Window',
    tags: {
      alfa: 'Artifact'
    },
    cta: 'Learn more',
    image: 'A14_19410001-003.jpg',
    link: '/learn/stained-glass-window/',
    cats: {
      themes: [113],
      types: [38]
    }
  },
  {
    id: 53,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Medal Set with Photograph',
    tags: {
      alfa: 'Artifact'
    },
    cta: 'Learn more',
    image: 'A15_20170206-001.jpg',
    link: '/learn/medal-set-with-photograph/',
    cats: {
      themes: [214],
      types: [38]
    }
  },
  {
    id: 54,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Helmet',
    tags: {
      alfa: 'Artifact'
    },
    cta: 'Learn more',
    image: 'A16_19920197-001.jpg',
    link: '/learn/helmet/',
    cats: {
      themes: [214],
      types: [38]
    }
  },
  {
    id: 55,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Fragmentation Vest',
    tags: {
      alfa: 'Artifact'
    },
    cta: 'Learn more',
    image: 'A17a_20180249-006.jpg',
    link: '/learn/fragmentation-vest/',
    cats: {
      themes: [312],
      types: [38]
    }
  },
  {
    id: 56,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Peacekeeping Monument Maquette',
    tags: {
      alfa: 'Artifact'
    },
    cta: 'Learn more',
    image: 'A18a_19960036-001_ongrey.jpg',
    link: '/learn/peacekeeping-monument-maquette/',
    cats: {
      themes: [312],
      types: [38]
    }
  },
  {
    id: 57,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Banner',
    tags: {
      alfa: 'Artifact'
    },
    cta: 'Learn more',
    image: 'A19_20120114-001.jpg',
    link: '/learn/banner/',
    cats: {
      themes: [414],
      types: [38]
    }
  },
  {
    id: 58,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Flag with Inscription',
    tags: {
      alfa: 'Artifact'
    },
    cta: 'Learn more',
    image: 'A20_20110171-001.jpg',
    link: '/learn/flag-with-inscription/',
    cats: {
      themes: [214, 511, 1311],
      types: [38]
    }
  },
  {
    id: 14,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: '<em>The Flag</em>',
    tags: {
      alfa: 'Art'
    },
    cta: 'Learn more',
    image: 'Art01-19710261-0656.jpg',
    link: '/learn/the-flag/',
    cats: {
      themes: [113],
      types: [43]
    }
  },
  {
    id: 15,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: '<em>Over the Top, Neuville-Vitasse</em>',
    tags: {
      alfa: 'Art'
    },
    cta: 'Learn more',
    image: 'Art02-19710261-0056.jpg',
    link: '/learn/over-the-top-neuville-vitasse/',
    cats: {
      themes: [113],
      types: [43]
    }
  },
  {
    id: 16,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: '<em>Behind the Wire</em>',
    tags: {
      alfa: 'Art'
    },
    cta: 'Learn more',
    image: 'Art03-20130078-001.jpg',
    link: '/learn/behind-the-wire/',
    cats: {
      themes: [214],
      types: [43]
    }
  },
  {
    id: 17,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: '<em>Casualty Clearing Post</em>',
    tags: {
      alfa: 'Art'
    },
    cta: 'Learn more',
    image: 'Art04-19710261-2042.jpg',
    link: '/learn/casualty-clearing-post/',
    cats: {
      themes: [214],
      types: [43]
    }
  },
  {
    id: 18,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: '<em>Peacekeepers</em>',
    tags: {
      alfa: 'Art'
    },
    cta: 'Learn more',
    image: 'Art05-19970043-001.jpg',
    link: '/learn/peacekeepers/',
    cats: {
      themes: [312, 1020],
      types: [43]
    }
  },
  {
    id: 19,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Untitled',
    tags: {
      alfa: 'Art'
    },
    cta: 'Learn more',
    image: 'Art06-19970052-001.jpg',
    link: '/learn/untitled/',
    cats: {
      themes: [312],
      types: [43]
    }
  },
  {
    id: 20,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: '<em>War</em>',
    tags: {
      alfa: 'Art'
    },
    cta: 'Learn more',
    image: 'Art07-20110073-003.jpg',
    link: '/learn/war/',
    cats: {
      themes: [414],
      types: [43]
    }
  },
  {
    id: 21,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: '<em>Slow March</em>',
    tags: {
      alfa: 'Art'
    },
    cta: 'Learn more',
    image: 'Art08-20110076-001-1280x906.jpg',
    link: '/learn/slow-march/',
    cats: {
      themes: [414, 511],
      types: [43]
    }
  },
  {
    id: 22,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: '<em>Unveiling Vimy Ridge Monument</em>',
    tags: {
      alfa: 'Art'
    },
    cta: 'Learn more',
    image: 'Art09-19670070-014.jpg',
    link: '/learn/unveiling-vimy-ridge-monument/',
    cats: {
      themes: [511],
      types: [43]
    }
  },
  {
    id: 23,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: '<em>Dreaver</em>',
    tags: {
      alfa: 'Art'
    },
    cta: 'Learn more',
    image: 'Art10-20180556-001.jpg',
    link: '/learn/dreaver/',
    cats: {
      themes: [511, 113, 214, 917, 1311],
      types: [43]
    }
  },
  {
    id: 59,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: '<em>Normandy Warrior<em>',
    tags: {
      alfa: 'Art'
    },
    cta: 'Learn more',
    image: 'Art11_20200359-001.jpg',
    link: '/learn/normandy-warrior/',
    cats: {
      themes: [214, 917, 1311],
      types: [43]
    }
  },
  {
    id: 60,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: '<em>The Parade<em>',
    tags: {
      alfa: 'Art'
    },
    cta: 'Learn more',
    image: 'Art12_il2008006-001_lower.jpg',
    link: '/learn/the-parade/',
    cats: {
      themes: [214, 1115, 1311],
      types: [43]
    }
  },
  {
    id: 61,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: '<em>Returning as a Bird<em>',
    tags: {
      alfa: 'Art'
    },
    cta: 'Learn more',
    image: 'Art13_20170667-001.jpg',
    link: '/learn/returning-as-a-bird/',
    cats: {
      themes: [214, 1311],
      types: [43]
    }
  },
  {
    id: 24,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Circumstances of Death Report',
    tags: {
      alfa: 'Document'
    },
    cta: 'Learn more',
    image: 'Doc01-20040015-007.jpg',
    link: '/learn/circumstances-of-death-report/',
    cats: {
      themes: [113],
      types: [58]
    }
  },
  {
    id: 25,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Field Service Postcard',
    tags: {
      alfa: 'Document'
    },
    cta: 'Learn more',
    image: 'Doc02-20060194-002_1.jpg',
    link: '/learn/field-service-postcard/',
    cats: {
      themes: [113],
      types: [58]
    }
  },
  {
    id: 26,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Letter, 4 June 1944',
    tags: {
      alfa: 'Document'
    },
    cta: 'Learn more',
    image: 'Doc03-20050108-003.jpg',
    link: '/learn/letter-4-june-1944/',
    cats: {
      themes: [214],
      types: [58]
    }
  },
  {
    id: 27,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Letter, 19 February 1944',
    tags: {
      alfa: 'Document'
    },
    cta: 'Learn more',
    image: 'Doc04-20030359-028_28_p1.jpg',
    link: '/learn/letter-19-february-1944/',
    cats: {
      themes: [214, 1115],
      types: [58]
    }
  },
  {
    id: 28,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Letter, 2 June 2000',
    tags: {
      alfa: 'Document'
    },
    cta: 'Learn more',
    image: 'Doc05-20130617-001_16_June_2000.jpg',
    link: '/learn/letter-2-june-2000/',
    cats: {
      themes: [312, 1115],
      types: [58]
    }
  },
  {
    id: 29,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Site #6 Diagram of Wounds and Summary',
    warningText: '<p><strong>Warning:</strong> This document contains detailed and graphic descriptions of wounds on a victim of ethnic genocide found by Canadians serving on a peacekeeping mission. It may not be suitable for all. <strong>Please consider whether this resource is appropriate for you before selecting it</strong>. </p>',
    tags: {
      alfa: 'Document',
      warning: 'Warning'
    },
    cta: 'Learn more',
    image: 'Doc06-20160257-003_Site-No6_Illustration.jpg',
    link: '/learn/site-6-diagram-of-wounds-and-summary/',
    cats: {
      themes: [312],
      types: [58]
    }
  },
  {
    id: 30,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'My Tour Diary',
    tags: {
      alfa: 'Document'
    },
    cta: 'Learn more',
    image: 'Doc07_20100094-003_1.jpg',
    link: '/learn/my-tour-diary/',
    cats: {
      themes: [414],
      types: [58]
    }
  },
  {
    id: 31,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Kabul Presidential Election Ballot',
    tags: {
      alfa: 'Document'
    },
    cta: 'Learn more',
    image: 'Doc08-20060136-001.jpg',
    link: '/learn/kabul-presidential-election-ballot/',
    cats: {
      themes: [414],
      types: [58]
    }
  },
  {
    id: 32,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'In Flanders’ Fields',
    tags: {
      alfa: 'Document'
    },
    cta: 'Learn more',
    image: 'Doc09-20060073-001.jpg',
    link: '/learn/in-flanders-fields/',
    cats: {
      themes: [511, 113],
      types: [58]
    }
  },
  {
    id: 33,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Programme, National Remembrance Day Ceremony, 1934',
    tags: {
      alfa: 'Document'
    },
    cta: 'Learn more',
    image: 'Doc10-19990092-068_eng.jpg',
    link: '/learn/programme-national-remembrance-day-ceremony-1934/',
    cats: {
      themes: [511],
      types: [58]
    }
  },
  {
    id: 62,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Scrapbook',
    tags: {
      alfa: 'Document'
    },
    cta: 'Learn more',
    image: 'Doc11a_20160159-001_p3.jpg',
    link: '/learn/scrapbook/',
    cats: {
      themes: [113, 1020, 1311],
      types: [58]
    }
  },
  {
    id: 63,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Public Recognition Certificate',
    tags: {
      alfa: 'Document'
    },
    cta: 'Learn more',
    image: 'Doc12a_20110057-009.jpg',
    link: '/learn/public-recognition-certificate/',
    cats: {
      themes: [214, 1020, 1115, 1311],
      types: [58]
    }
  },
  {
    id: 64,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Newspaper Article, 18 June 1945',
    tags: {
      alfa: 'Document'
    },
    cta: 'Learn more',
    image: 'Doc13_WindsorStar18June45p3_JosephHong.jpg',
    link: '/learn/newspaper-article-18-june-1945/',
    cats: {
      themes: [214, 1220],
      types: [58]
    }
  },
  {
    id: 65,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Letters, 13 September 1979 and 6 January 1980',
    tags: {
      alfa: 'Document'
    },
    cta: 'Learn more',
    image: 'Doc14a_20030023-062_6-Jan-1980.jpg',
    link: '/learn/letters-13-September-1979-and-6-January-1980/',
    cats: {
      themes: [312, 1220],
      types: [58]
    }
  },
  {
    id: 66,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Embroidered Card, 2 December 1916',
    tags: {
      alfa: 'Document'
    },
    cta: 'Learn more',
    image: 'Doc15a_19830409-005_front.jpg',
    link: '/learn/embroidered-card-2-December-1916/',
    cats: {
      themes: [113, 917],
      types: [58]
    }
  },
  {
    id: 67,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Letter, 18 August 1915',
    tags: {
      alfa: 'Document'
    },
    cta: 'Learn more',
    image: 'Doc16a1_20070019-001_18-Aug-1915_1.jpg',
    link: '/learn/letter-18-August-1915',
    cats: {
      themes: [113, 917],
      types: [58]
    }
  },
  {
    id: 68,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Buy a Poppy …',
    tags: {
      alfa: 'Document'
    },
    cta: 'Learn more',
    image: 'Doc17a_Poppy-Campaign-ad.jpg',
    link: '/learn/buy-a-poppy/',
    cats: {
      themes: [511, 1115],
      types: [58]
    }
  },
  {
    id: 69,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Royal Canadian Legion Poster Contest Winners, 2020',
    tags: {
      alfa: 'Document'
    },
    cta: 'Learn more',
    image: 'Doc18a_Maximilian-Lee.jpg',
    link: '/learn/royal-canadian-legion-poster-contest-winners-2020/',
    cats: {
      themes: [511],
      types: [58]
    }
  },
  {
    id: 70,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Newspaper Article, 12 November 1941',
    tags: {
      alfa: 'Document'
    },
    cta: 'Learn more',
    image: 'Doc19_Ott-Citizen-12-Nov-1941-p-22_Armistice-of-1918.jpg',
    link: '/learn/newspaper-article-12-november-1941/',
    cats: {
      themes: [511, 214],
      types: [58]
    }
  },
  {
    id: 34,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: '107th Pioneer Battalion',
    tags: {
      alfa: 'Photograph'
    },
    cta: 'Learn more',
    image: 'P01-il2015015-005.jpg',
    link: '/learn/107th-pioneer-battalion/',
    cats: {
      themes: [113, 917],
      types: [610]
    }
  },
  {
    id: 35,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'The Headquarters, Canadian Army Veterinary Corps, Shorncliffe',
    tags: {
      alfa: 'Photograph'
    },
    cta: 'Learn more',
    image: 'P02-19930003-453.jpg',
    link: '/learn/the-headquarters-canadian-army-veterinary-corps-shorncliffe/',
    cats: {
      themes: [113],
      types: [610]
    }
  },
  {
    id: 36,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Private Mary Greyeyes, from Maskêko-Sâkahikanihk (Muskeg Lake, Cree Nation), Canadian Women’s Army Corps, with Harry Ball, Piapot First Nation',
    tags: {
      alfa: 'Photograph'
    },
    cta: 'Learn more',
    image: 'P03-PA-129070.jpg',
    link: '/learn/private-mary-greyeyes/',
    cats: {
      themes: [214, 917, 1115],
      types: [610]
    }
  },
  {
    id: 37,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: '53 Redwood Avenue, Toronto',
    tags: {
      alfa: 'Photograph'
    },
    cta: 'Learn more',
    image: 'P04-20180400-002_1.jpg',
    link: '/learn/53-redwood-avenue-toronto/',
    cats: {
      themes: [214, 1020],
      types: [610]
    }
  },
  {
    id: 38,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'United Nations Assistance Mission for Rwanda team',
    tags: {
      alfa: 'Photograph'
    },
    cta: 'Learn more',
    image: 'P05-20140588-002-3.jpg',
    link: '/learn/united-nations-assistance-mission-for-rwanda-team/',
    cats: {
      themes: [312],
      types: [610]
    }
  },
  {
    id: 39,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Operation HAMLET',
    tags: {
      alfa: 'Photograph'
    },
    cta: 'Learn more',
    image: 'P06-IS2013-2002-058.jpg',
    link: '/learn/operation-hamlet/',
    cats: {
      themes: [312],
      types: [610]
    }
  },
  {
    id: 40,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Operation ATHENA, Medical Clinic',
    tags: {
      alfa: 'Photograph'
    },
    cta: 'Learn more',
    image: 'P07-AR2008-Z103-19.jpg',
    link: '/learn/operation-athena-medical-clinic/',
    cats: {
      themes: [414, 1115],
      types: [610]
    }
  },
  {
    id: 41,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Operation ATHENA, Force Protection Company',
    tags: {
      alfa: 'Photograph'
    },
    cta: 'Learn more',
    image: 'P08-IS2007-1018.jpg',
    link: '/learn/operation-athena-force-protection-company/',
    cats: {
      themes: [414],
      types: [610]
    }
  },
  {
    id: 42,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'At the Formal Unveiling of Vimy Memorial',
    tags: {
      alfa: 'Photograph'
    },
    cta: 'Learn more',
    image: 'P09-19830626-001_3.jpg',
    link: '/learn/at-the-formal-unveiling-of-vimy-memorial/',
    cats: {
      themes: [511, 1115, 1220],
      types: [610]
    }
  },
  {
    id: 43,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: '100th Anniversary Parade',
    tags: {
      alfa: 'Photograph'
    },
    cta: 'Learn more',
    image: 'P10_IS13-2018-0004-010.jpg',
    link: '/learn/100th-anniversary-parade/',
    cats: {
      themes: [511],
      types: [610]
    }
  },
  {
    id: 71,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Ainsworth Dyer Memorial Bridge, Edmonton, Alberta',
    tags: {
      alfa: 'Photograph'
    },
    cta: 'Learn more',
    image: 'P11a_39824078.jpg',
    link: '/learn/ainsworth-dyer-memorial-bridge-edmonton-alberta/',
    cats: {
      themes: [414, 1020],
      types: [610]
    }
  },
  {
    id: 72,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Japanese Canadian Community Members in Mourning, Vancouver, British Columbia',
    tags: {
      alfa: 'Photograph'
    },
    cta: 'Learn more',
    image: 'P12_2001-11-054-Funeral.jpg',
    link: '/learn/japanese-canadian-community-members-in-mourning-vancouver-british-columbia/',
    cats: {
      themes: [113, 1220],
      types: [610]
    }
  },
  {
    id: 72,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Ceremony at the Grave of Veteran Buckam Singh',
    tags: {
      alfa: 'Photograph'
    },
    cta: 'Learn more',
    image: 'P13_sandeep-brar.jpg',
    link: '/learn/ceremony-at-the-grave-of-veteran-buckam-singh/',
    cats: {
      themes: [113, 511, 1220],
      types: [610]
    }
  },
  {
    id: 73,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Masumi Mitsui Holding a Picture of Himself as a First World War Soldier',
    tags: {
      alfa: 'Photograph'
    },
    cta: 'Learn more',
    image: 'P14_Mitsui_2014-10-1-7.jpg',
    link: '/learn/masumi-mitsui-holding-a-picture-of-himself-as-a-first-world-war-soldier/',
    cats: {
      themes: [113, 214, 511, 1311, 1220],
      types: [610]
    }
  },
  {
    id: 74,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Memorial Cup',
    tags: {
      alfa: 'Photograph'
    },
    cta: 'Learn more',
    image: 'P15a_130516_Cup_Arrival.jpg',
    link: '/learn/memorial-cup/',
    cats: {
      themes: [113],
      types: [610]
    }
  },
  {
    id: 75,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Lily and Donald Worden at the Gravesite of Edwin Worden',
    tags: {
      alfa: 'Photograph'
    },
    cta: 'Learn more',
    image: 'P16_19800746-010.jpg',
    link: '/learn/lily-and-donald-worden-at-the-gravesite-of-edwin-worden/',
    cats: {
      themes: [214],
      types: [610]
    }
  },
  {
    id: 76,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Remembrance Day at Tim Hortons, Kandahar, Afghanistan',
    tags: {
      alfa: 'Photograph'
    },
    cta: 'Learn more',
    image: 'P17a_Tims-Poppies-7.jpg',
    link: '/learn/remembrance-day-at-tim-hortons-kandahar-afghanistan',
    cats: {
      themes: [511, 1115, 414],
      types: [610]
    }
  },
  {
    id: 77,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Burial at Sea',
    tags: {
      alfa: 'Photograph'
    },
    cta: 'Learn more',
    image: 'P18_20000224-028_7.jpg',
    link: '/learn/burial-at-sea',
    cats: {
      themes: [214],
      types: [610]
    }
  },
  {
    id: 50,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Canada and the First World War',
    tags: {
      alfa: 'Historical Overview'
    },
    cta: 'Learn more',
    image: 'Ov01-19930013-464.jpg',
    link: '/learn/canada-and-the-first-world-war/',
    cats: {
      themes: [113],
      types: [218]
    }
  },
  {
    id: 51,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Canada and the Second World War',
    tags: {
      alfa: 'Historical Overview'
    },
    cta: 'Learn more',
    image: 'Ov02-PA-113659.jpg',
    link: '/learn/canada-and-the-second-world-war/',
    cats: {
      themes: [214],
      types: [218]
    }
  },
  {
    id: 52,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Canada and Peacekeeping Operations',
    tags: {
      alfa: 'Historical Overview'
    },
    cta: 'Learn more',
    image: 'Ov03-19910238-130.jpg',
    link: '/learn/canada-and-peacekeeping-operations/',
    cats: {
      themes: [312],
      types: [218]
    }
  },
  {
    id: 53,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Canada and the Afghanistan War',
    tags: {
      alfa: 'Historical Overview'
    },
    cta: 'Learn more',
    image: 'Ov04-AR2006-P005-0031.jpg',
    link: '/learn/canada-and-the-afghanistan-war/',
    cats: {
      themes: [414],
      types: [218]
    }
  },
  {
    id: 54,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Canada Remembers',
    tags: {
      alfa: 'Historical Overview'
    },
    cta: 'Learn more',
    image: 'ov5_cwn2011-0065-0006-dp1.jpg',
    link: '/learn/canada-remembers/',
    cats: {
      themes: [511],
      types: [218]
    }
  },
  {
    id: 78,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Women in the Canadian Military',
    tags: {
      alfa: 'Historical Overview'
    },
    cta: 'Learn more',
    image: 'ov7_e010777310-v8_1.jpg',
    link: '/learn/women-in-the-canadian-military/',
    cats: {
      themes: [1115, 113, 214],
      types: [218]
    }
  },
  {
    id: 85,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Canada’s Veterans',
    tags: {
      alfa: 'Historical Overview'
    },
    cta: 'Learn more',
    image: 'cwm2018-0037-0058-dm.jpg',
    link: '/learn/canadas-veterans/',
    cats: {
      themes: [1311, 113, 214, 511],
      types: [218]
    }
  },
  {
    id: 86,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Indigenous Peoples and Canada’s Military',
    tags: {
      alfa: 'Historical Overview'
    },
    cta: 'Learn more',
    image: 'arnold-moses-front-right-wesley-burnham-front-left-107th-battalion-cef.jpg',
    link: '/learn/indigenous-peoples-and-canadas-military/',
    cats: {
      themes: [917],
      types: [218]
    }
  },
  {
    id: 87,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Asian Canadians and Canada’s Military',
    tags: {
      alfa: 'Historical Overview'
    },
    cta: 'Learn more',
    image: '1942-chinese-canadian-recruits-victoria.jpg',
    link: '/learn/asian-canadians-and-canadas-military/',
    cats: {
      themes: [1220],
      types: [218]
    }
  },
  {
    id: 88,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Black Canadians and Canada’s Military',
    tags: {
      alfa: 'Historical Overview'
    },
    cta: 'Learn more',
    image: 'ov10_lac-pa-22980_cropped.jpg',
    link: '/learn/black-canadians-and-canadas-military/',
    cats: {
      themes: [1020],
      types: [218]
    }
  },
  {
    id: 1,
    isActive: true,
    subClasses: ['mu-grid'],
    section: 'exhibitions',
    // ***
    // ^ Utility props!, consider moving to keep ensure base data is in fact data only.
    // .. of course, not a priority since it likely won't matter much ;-)
    title: 'Organizing a Remembrance Day Ceremony',
    // desc: "Developed to mark the 75th anniversary of the end of the Second World War, Forever Changed weaves together a diverse range of stories with nearly 200 compelling artifacts, exploring the human experience ...",
    tags: {
      alfa: 'Activity'
    },
    cta: 'Learn more',
    image: false,
    link: '/learn/organizing-a-remembrance-day-ceremony/',
    cats: {
      themes: [511],
      types: [18]
    }
  },
  {
    id: 2,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Discussing Art and Photographs',
    tags: {
      alfa: 'Activity'
    },
    cta: 'Learn more',
    image: false,
    link: '/learn/discussing-art-and-photographs/',
    cats: {
      themes: [],
      types: [18]
    }
  },
  {
    id: 200,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'How to Analyze a Primary Source',
    tags: {
      alfa: 'Activity'
    },
    cta: 'Learn more',
    image: false,
    link: '/learn/how-to-analyze-a-primary-source/',
    cats: {
      themes: [],
      types: [18]
    }
  },
  {
    id: 3,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'How to Analyze an Artifact',
    tags: {
      alfa: 'Activity'
    },
    cta: 'Learn more',
    image: false,
    link: '/learn/how-to-analyze-an-artifact/',
    cats: {
      themes: [],
      types: [18]
    }
  }
]);